import { IsString } from 'class-validator';

export class ApplePayValidateSessionRequestDto {
  @IsString()
  appleUrl: string;

  @IsString()
  displayName: string;

  @IsString()
  webUrl: string;

  @IsString()
  merchantId?: string;
}
